import openSocket from "socket.io-client";

const baseUrl = () => {
  if (process.env.NODE_ENV !== 'development') {    
    return 'https://api.fynd.com.br'
  } else {
    return 'http://localhost:3001'
  }
};

const socket = openSocket(baseUrl(), {
  reconnection: true,
  reconnectionDelay: 1000,
  reconnectionDelayMax: 5000,
  secure: true,
  reconnectionAttempts: Infinity,
  transports: ["websocket"],
  rejectUnauthorized: false,
  jsonp: false,
  randomizationFactor: 0.5,
});

socket.on("connect_error", () => {
  setTimeout(() => {
    socket.connect();
  }, 2000);
});

socket.on("disconnect", () => {
  setTimeout(() => {
    socket.connect();
  }, 500);
});

const ioOnDash = (id, cb) => {
  socket.on(`dash-adm`, (data) => cb(data));
};

const ioOnPedido = (id, cb) => {
  socket.on(`pedido-${id}`, (data) => cb(data));
};

const ioClosePedido = (id, cb) => {
  socket.removeEventListener(`pedido-${id}`, () => cb());
};

export { ioOnPedido, ioClosePedido, ioOnDash };
